// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-center-card .image-placeholder {\n  width: 60px;\n  height: 60px;\n}\n.notification-center-card .image-placeholder p {\n    display: none;\n}\n", ""]);
// Exports
module.exports = exports;
